// 最顶部先拦截路由相关错误，连控制台打印都屏蔽
const originalConsoleError = console.error
console.error = function(...args) {
  // 过滤路由重定向的错误消息
  const msg = args[0]?.toString() || ''
  if (msg.includes('Redirected when going from') && msg.includes('via a navigation guard')) {
    return
  }
  originalConsoleError.apply(console, args)
}

window.addEventListener('unhandledrejection', (e) => {
  const err = e.reason
  // 忽略路由重定向和重复导航的错误
  if (err?.name === 'NavigationRedirected' || err?.name === 'NavigationDuplicated') {
    e.preventDefault()
    e.stopPropagation()
    return false
  }
}, true)

import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import {
  Button, Cell, CellGroup, Icon, Tabbar, TabbarItem, NavBar,
  Search, Swipe, SwipeItem, Grid, GridItem, Card, Tag,
  GoodsAction, GoodsActionIcon, GoodsActionButton, Stepper,
  SubmitBar, Checkbox, CheckboxGroup, Popup, AddressList, AddressEdit,
  Tab, Tabs, PullRefresh, List, Empty, Dialog, Toast, Notify, Loading,
  Image as VanImage, Lazyload, Divider, Uploader, Rate, Field,
  Form, CountDown, SwipeCell, Card as VanCard, Picker, Switch, Area, Calendar
} from 'vant'
import 'vant/lib/index.css'
import './assets/css/global.scss'

Vue.config.productionTip = false

// 全局捕获Vue错误，忽略路由重定向的不影响功能的报错
Vue.config.errorHandler = (err, vm, info) => {
  if (err?.name === 'NavigationRedirected' || err?.name === 'NavigationDuplicated') {
    return false
  }
  console.error('Vue错误:', err, info)
}

import api from './api';
console.log('获取当前API',api);

// 注册Vant组件
Vue.use(Button).use(Cell).use(CellGroup).use(Icon).use(Tabbar).use(TabbarItem)
.use(NavBar).use(Search).use(Swipe).use(SwipeItem).use(Grid).use(GridItem)
.use(Card).use(Tag).use(GoodsAction).use(GoodsActionIcon).use(GoodsActionButton)
.use(Stepper).use(SubmitBar).use(Checkbox).use(CheckboxGroup).use(Popup)
.use(AddressList).use(AddressEdit).use(Tab).use(Tabs).use(PullRefresh).use(List)
.use(Empty).use(Dialog).use(Toast).use(Notify).use(Loading).use(VanImage).use(Lazyload)
.use(Divider).use(Uploader).use(Rate).use(Field).use(Form).use(CountDown)
.use(SwipeCell).use(VanCard).use(Picker).use(Switch).use(Area).use(Calendar)

// 全局挂载常用方法
Vue.prototype.$toast = Toast
Vue.prototype.$dialog = Dialog
Vue.prototype.$notify = Notify
Vue.prototype.$api = api;

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
